<header class="fixed w-full text-white p-0 pl-5 top-0">
  <div class="logo h-full bg-no-repeat bg-center"></div>
</header>
